module.exports = ".btn-mine{\r\n     border: 1px solid #17a2b8;\r\n}\r\n.btn-group .btn{\r\n     min-width: 5px;\r\n }\r\n.btn-group i{  \r\n     color: white;\r\n }"


//////////////////
// WEBPACK FOOTER
// ./src/app/Pages/activities/activity-grid/activity-grid.component.css
// module id = ./src/app/Pages/activities/activity-grid/activity-grid.component.css
// module chunks = main